export const filterActiveUserOptions = (users) =>
	users
		.filter((user) => user.active)
		.map((user) => ({ label: user.username, value: user._id }));
